export default "__VITE_ASSET__Da7rmFBJ__"